import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const LoaderText = styled.p`
    margin: 24px 0 0;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p01Regular')}
`
